import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import {Dialog} from 'vant'
import {Picker} from 'vant'

import initWeiXin from './utils/share';

import '@/components/index'
import 'vant/lib/index.css'
import './assets/css/index.scss'
import './assets/icon'

Vue.config.productionTip = false
Vue.prototype.$WeiXin = initWeiXin; 

Vue.use(Vant);
Vue.use(Dialog);
Vue.use(Picker);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
